module.exports = __webpack_public_path__ + "assets/icons/ic_notifications_24px.svg";